import { map, omit } from 'lodash';
import { flattenToAppURL } from '@plone/volto/helpers';
import { GET_SCHEDAPERSONA_RESULTS } from 'uniba-volto-persone/actions';

const initialState = {
  error: null,
  items: [],
  total: 0,
  loaded: false,
  loading: false,
  batching: {},
  subrequests: {},
};

/**
 * schedapersona search reducer.
 * @function querystring
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export function searchSchedaPersonaReducer(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SCHEDAPERSONA_RESULTS}_PENDING`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                ...(state.subrequests[action.subrequest] || {
                  items: [],
                  total: 0,
                  batching: {},
                }),
                items: [],
                total: 0,
                error: null,
                loaded: false,
                loading: true,
                afferenze: null,
              },
            },
          }
        : {
            ...state,
            error: null,
            loading: true,
            loaded: false,
            afferenze: null,
          };
    case `${GET_SCHEDAPERSONA_RESULTS}_SUCCESS`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: null,
                items: map(action.result.items, (item) => ({
                  ...item,
                  '@id': flattenToAppURL(item['@id']),
                })),
                total: action.result.items_total,
                loaded: true,
                loading: false,
                batching: { ...action.result.batching },
                afferenze: action.result.afferenze,
              },
            },
          }
        : {
            ...state,
            error: null,
            items: map(action.result.items, (item) => ({
              ...item,
              '@id': flattenToAppURL(item['@id']),
            })),
            total: action.result.items_total,
            loaded: true,
            loading: false,
            batching: { ...action.result.batching },
            afferenze: action.result.afferenze,
          };
    case `${GET_SCHEDAPERSONA_RESULTS}_FAIL`:
      return action.subrequest
        ? {
            ...state,
            subrequests: {
              ...state.subrequests,
              [action.subrequest]: {
                error: action.error,
                items: [],
                total: 0,
                loading: false,
                loaded: false,
                batching: {},
                afferenze: null,
              },
            },
          }
        : {
            ...state,
            error: action.error,
            items: [],
            total: 0,
            loading: false,
            loaded: false,
            batching: {},
            afferenze: null,
          };
    default:
      return state;
  }
}
